import { MaybeRef } from 'vue'
import { CustomFieldTypeValueInput, RateType } from '@/gql/graphql'
import { useJobRateCardBandQuery } from '@/components/Job/composables/useJobRateCardBandQuery'

export function useRateCardBand(options: {
  jobId: MaybeRef<string | undefined>
  customFieldValues: MaybeRef<CustomFieldTypeValueInput[]>
  bandRateType: MaybeRef<RateType | undefined>
  enabled: MaybeRef<boolean>
}) {
  return useJobRateCardBandQuery(options)
}
